// El menú lateral del hub y qué parte puede ver el rol «equipo» (Javi, 7 oct
// 2026: «cada opción del sidebar debería ser configurable por el
// administrador para permitirse ver o no por el equipo»).
//
// Puro (sin BD): lo usan la barra lateral (cliente) y la tarjeta de
// /usuarios. Lo que el admin oculta se guarda en lib/menu-equipo.ts.

export interface ItemMenu { href: string; label: string }
export interface SeccionMenu { titulo: string; items: ItemMenu[] }

export const MENU: SeccionMenu[] = [
  {
    titulo: "General",
    items: [
      { href: "/", label: "Dashboard" },
      { href: "/clientes", label: "Clientes" },
      { href: "/tareas", label: "Tareas" },
    ],
  },
  {
    titulo: "Creación",
    items: [
      { href: "/marca", label: "Identidad de marca" },
      { href: "/campanas", label: "Campañas" },
      { href: "/contenido", label: "Contenido" },
      { href: "/articulos", label: "Artículos" },
      { href: "/calendario", label: "Calendario" },
      { href: "/redes", label: "Redes sociales" },
      { href: "/influencers", label: "Influencers" },
      { href: "/activos", label: "Activos" },
    ],
  },
  {
    titulo: "Entregables",
    items: [
      { href: "/emails", label: "Emails" },
      { href: "/presupuestos", label: "Presupuestos" },
      { href: "/landings", label: "Landings" },
      { href: "/animaciones", label: "Animaciones" },
      { href: "/notas-prensa", label: "Notas de prensa" },
      { href: "/aprobaciones", label: "Aprobaciones" },
    ],
  },
  {
    titulo: "Rendimiento",
    items: [
      { href: "/ads", label: "Paid media" },
      { href: "/seo", label: "SEO" },
      { href: "/informes", label: "Informes" },
    ],
  },
  {
    titulo: "Negocio",
    items: [
      { href: "/prospeccion", label: "Prospección" },
      { href: "/facturacion", label: "Facturación" },
      { href: "/automatizaciones", label: "Automatizaciones" },
    ],
  },
];

/** El enlace del pie de la barra. También se puede ocultar al equipo. */
export const AJUSTES: ItemMenu = { href: "/ajustes", label: "Ajustes" };

/** El Dashboard no se oculta nunca: es la portada del hub. */
export const SIEMPRE_VISIBLE = "/";

export const TODOS_LOS_ITEMS: ItemMenu[] = [...MENU.flatMap((s) => s.items), AJUSTES];

/** Se queda solo con hrefs que existen en el menú y se pueden ocultar. */
export function limpiarOcultas(hrefs: unknown): string[] {
  if (!Array.isArray(hrefs)) return [];
  const validos = new Set(TODOS_LOS_ITEMS.map((i) => i.href).filter((h) => h !== SIEMPRE_VISIBLE));
  return [...new Set(hrefs.filter((h): h is string => typeof h === "string" && validos.has(h)))];
}
